import React, { useState, useReducer, useEffect } from "react";

// Components imports
import RegisterForm from "../../components/RegisterForm";

import { useHistory } from "react-router-dom";

// Scss imports
import css from "./Register.module.scss";

interface RegisterProps {}

const Register: React.FC<RegisterProps> = ({}) => {
  // Setting state for disabled button
  const [disabledButton, setDisabledButton] = useState(true);

  // Setting up state to hold informations about is state valid or no
  const [validPassword, setValidPassword] = useState(false);

  // Setting up variables
  let history = useHistory();

  // Setting up state to store input values
  const [userInput, setUserInput] = useReducer(
    (state: any, newState: any) => ({ ...state, ...newState }),
    {
      email: "",
      password: "",
      repeatedPassword: ""
    }
  );

  // Setting up error text state
  const [errorText, setErrorText] = useReducer(
    (state: any, newState: any) => ({ ...state, ...newState }),
    {
      email: "",
      password: "",
      repeatedPassword: ""
    }
  );

  // Using use effect hook to watch change of inputs and when we will input pass and input email make button enabled
  useEffect(() => {
    // Set button status to enabled when all fields are valid
    if (
      userInput.email.match(
        "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$"
      ) != null &&
      userInput.password.match(
        "^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$"
      ) != null &&
      userInput.repeatedPassword === userInput.password
    ) {
      setDisabledButton(false);
    }

    if (userInput.repeatedPassword === userInput.password) {
      setErrorText({
        repeatedPassword: ""
      });
    }
  }, [userInput.email, userInput.password, userInput.repeatedPassword]);

  // Login button handler
  const onClickButtonHandler = (e: any) => {
    e.preventDefault();
    history.push("/login");
  };

  // On input change set input name and value to text that user added
  const handleChange = (e: any, userInputType) => {
    const name = e.target.name;
    const newValue = e.target.value;
    setUserInput({ [name]: newValue });

    if (e.target.name === "repeatedPassword") {
      if (
        userInput.password.match(
          "^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$"
        ) == null
      ) {
        setErrorText({
          repeatedPassword: "Прво унесите вашу шифру"
        });
      } else if (userInput.repeatedPassword !== userInput.password) {
        setErrorText({
          repeatedPassword: "Ваше шифре се не подударају"
        });
        setDisabledButton(true);
      }
    }
  };

  // Set error on input
  const onInputHandler = (e, errorType, error, pattern) => {
    const newValue = e.target.value;
    // Validation with pattern
    if (newValue.match(pattern) == null) {
      setErrorText({
        [errorType]: error
      });
      setDisabledButton(true);
    }
    if (newValue.match(pattern) != null) {
      setErrorText({
        [errorType]: ""
      });
    }
  };

  return (
    <div className={css.container}>
      <div className={css.registerFormWrapper}>
        <h1>Региструј се</h1>
        <RegisterForm
          onClickButtonHandler={onClickButtonHandler}
          handleChange={handleChange}
          disabledButton={disabledButton}
          email={userInput.email}
          password={userInput.password}
          repeatedPassword={userInput.repeatedPassword}
          errorEmailText={errorText.email}
          errorPasswordText={errorText.password}
          errorRepeatedPasswordText={errorText.repeatedPassword}
          onInputPassword={(e) =>
            onInputHandler(
              e,
              "password",
              "Шифра треба да има најмање осам карактера, барем једно велико слово, барем једино мало слово и барем један број",
              "^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$"
            )
          }
          onInputEmail={(e) =>
            onInputHandler(
              e,
              "email",
              "Унеси исправну имејл адресу",
              "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$"
            )
          }
        />
      </div>
    </div>
  );
};

export default Register;
